import React from "react";
import styled, { css } from "styled-components";

const StyledIcon = styled.svg`
  ${({ ...props }) => css`
    color: ${props.theme.colors.primary};
  `}
`;

function HalfStarSmallIcon() {
  return (
    <StyledIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="currentColor" fillRule="nonzero" className="cat-fill">
          <path d="M15.18 5.36l-4.369-.666L8.86.557a.94.94 0 00-1.717 0L5.19 4.693l-4.37.666C.037 5.478-.277 6.487.29 7.065l3.16 3.218-.747 4.547c-.106.65.389 1.17.943 1.17a.91.91 0 00.444-.117L8 13.737l3.908 2.146c.145.08.296.116.442.116.556 0 1.052-.519.946-1.168l-.748-4.547 3.162-3.218c.568-.578.254-1.588-.53-1.706zm-3.633 3.85l-.541.55.127.778.583 3.545-3.049-1.675L8 12.042 8 2.129l1.524 3.228.333.707.747.114 3.41.52-2.467 2.512z"></path>
        </g>
      </g>
    </StyledIcon>
  );
}

export default HalfStarSmallIcon;
